import VideoCardBody from './VideoCardBody';

export default VideoCardBody;
